import axios from 'axios';
import React, { useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form';
import ApiResponeMessageBox from '../../../components/apimessages/ApiResponeMessageBox';

type formDataType = {
    lang: string,
    lang_code: string
}
const TabAdd = () => {

    const { register, handleSubmit, formState: { errors } } = useForm<formDataType>();

    const [loading, setLoading] = useState(false);
    const initialApiRes = {
        type: '',
        msg: ''
    }
    const [apiRes, setApiRes] = useState(initialApiRes)
    // const [validationsErr, setValidationsErr] = useState<FieldValidationErros>([])

    const onSubmit: SubmitHandler<formDataType> = async (data) => {
        try {
            setLoading(true)
            await axios.post(`${process.env.REACT_APP_API}/lang/create`, {
                lang_code: data.lang_code,
                lang: data.lang,
            }).then(res => {
                // setValidationsErr([])
                setApiRes({
                    type: 'success',
                    msg: res.data.message
                })
                setTimeout(() => {
                    setApiRes(initialApiRes)
                }, 2000);
            })
        } catch (error: any) {
            setLoading(false)
            if (error.response.data.errors) {
                setApiRes({
                    type: '',
                    msg: ''
                })
                // setValidationsErr(error.response.data.errors)
                console.log(error.response.data.errors)
            }
            if (error.response.data.err) {
                // setValidationsErr([])
                setApiRes({
                    type: 'error',
                    msg: error.response.data.message
                })
                setTimeout(() => {
                    setApiRes(initialApiRes)
                }, 3000);
            }
        }
        setLoading(false)
    }
    return (
        <div className='w-full'>
            {apiRes.msg && <ApiResponeMessageBox type={apiRes.type} msg={apiRes.msg} />}
            {/* <h2 className="font-bold">Create new languge</h2> */}
            <form className="w-fit my-10" onSubmit={handleSubmit(onSubmit)}>
                <div className="flex flex-col space-y-3 my-4">
                    <label htmlFor="lang">Langugae</label>
                    <input type="text" className='form-input inputs md:w-96' required placeholder='Enter a languge....' {...register("lang")} />
                </div>

                <div className="flex flex-col space-y-3 my-4">
                    <label htmlFor="lang">Langugae Code</label>
                    <input type="text" className='form-input inputs md:w-96' required placeholder='Languge code like English (Eng)....' {...register("lang_code")} />
                </div>

                <div className="flex flex-col space-y-3 my-4">
                    <input type="submit" className='btn btn-primary' value={loading ? 'Loading...' : 'Submit'} />
                </div>

            </form>
        </div>
    )
}

export default TabAdd